import { render } from "./ResearchCreatorWidget.vue?vue&type=template&id=717199fd"
import script from "./ResearchCreatorWidget.vue?vue&type=script&lang=js"
export * from "./ResearchCreatorWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__